import * as React from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Image,
  Platform
} from "react-native";
import Colors from "../../utilities/Color.js";
import { Ionicons } from "@expo/vector-icons";
import { disableAdBanner } from "../../redux/actions/UIStateActions.js";
import GlobalStyles from "../../components/GlobalStyles";


export default function AdBanner() {

  // const [showBanner, setShowBanner] = React.useState(true);
  const showBanner = true;
  const shellLogo = require("../../assets/images/shell/shellIcon.png")

  return (
    <View>{showBanner == true ?
      <View style={styles.mainContainer}>
        <View style={styles.barContainer}>
          <View style={styles.textMenuLeftContainer}>
            <Text>
              <Text style={styles.textWhite} >
                Download the
              </Text>
              <Text style={styles.textBlack}>
                Aura Buy Invest Donate
              </Text>
              <Text style={styles.textWhite}>
                app and redeem your
              </Text>
              <Text style={styles.textBlack}>
                Fuel Cash Back*
              </Text>
              <Text style={[styles.textWhite]}>
                rewards with our official fuel partner
              </Text>
            </Text>
          </View>
          <View style={styles.rightContainer}>
            <View style={styles.shellImageContainer}>
              <Image style={styles.shellLogo} source={shellLogo} />
            </View>
            {Platform.OS === "web" ? (
              <Text style={[styles.textWhite, { alignSelf: "center", marginRight: 10, textDecorationLine: 'underline' }]}
                onPress={() =>
                  window.open("https://aura.club/promotional-terms-and-conditions/", "_blank")
                }
              >
                *T&Cs apply
              </Text>) : (
              <Text style={[styles.textWhite, { alignSelf: "center", marginRight: 5, textDecorationLine: 'underline' }]}
                onPress={() => Linking.openURL("https://aura.club/promotional-terms-and-conditions/")
                }
              >
                *T&Cs apply
              </Text>)}
            <Ionicons name="logo-apple" size={20} color={Colors.WHITE}
              style={{ marginRight: 10, alignSelf: "center", alignContent: "center" }}
              onPress={() => window.open("https://apps.apple.com/au/app/aura-buy-invest-donate/id1524423902?platform=iphone", "_blank")} />
            <Ionicons name="logo-google-playstore" size={20}
              color={Colors.WHITE} style={{ alignSelf: "center" }}
              onPress={() => window.open("https://play.google.com/store/apps/details?id=au.com.auraloyalty.aura", "_blank")}
            />
          </View>
          <View style={styles.closeButtonContainer}>
            <TouchableOpacity
              onPress={() => disableAdBanner(false)}
            >
              <Ionicons
                name="md-close-outline"
                size={20}
                color={Colors.WHITE}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    alignItems: "center",
    alignSelf: "center"
  },
  barContainer: {
    flex: 1,
    flexDirection: "row",
    marginRight: 10,
    paddingLeft: 10,
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
    backgroundColor: "#4EBDEF",
    height: 32,
    alignItems: "center",
    width: 1000,
    paddingTop: 1,
    paddingBottom: 1
  },
  textMenuLeftContainer: {
    flex: 3.9,
    alignItems: "flex-start",
    marginRight: 10,
    marginLeft: 15,
    alignContent: "center",
  },
  textWhite: {
    fontSize: 12,
    fontFamily: "montserrat-medium",
    color: Colors.WHITE,
    marginRight: 5,
    alignContent: "center"
  },
  textBlack: {
    fontSize: 12,
    fontFamily: "montserrat-bold",
    color: "#333333",
    marginRight: 5,
    alignContent: "center"
  },
  middleshellImageContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  shellImageContainer: {
    paddingRight: 3,
    paddingLeft: 3,
    backgroundColor: Colors.WHITE,
    marginLeft: -35,
    marginRight: 10
  },
  shellLogo: {
    height: 28,
    width: 70,
    resizeMode: "contain",
  },
  rightContainer: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
  },
  closeButtonContainer: {
    alignItems: "flex-end",
    alignSelf: "center",
    paddingRight: 10
  }
});